import request from '../request';
import { userProvisioningAPI } from './urls';

// Admin-Api user provisioning — the second half of the Add User flow. After the Identity
// invite creates the user (and returns its userId), these calls wire that user's access
// into the Admin domain (both the legacy dashboards and the new system), exactly as the
// People Management app's access-management flow does.

// POST /api/UserProvisioning/provision — provisions the just-invited user.
// body: { userId, email, firstName, lastName, userRole, schoolStaffId, sites:[], access:[roleIds], matGroupId }
const provisionUser = (provisioningData) =>
  request({
    url: userProvisioningAPI.provision,
    method: 'POST',
    data: provisioningData,
  });

// DELETE /api/UserProvisioning/{userId} — rolls back provisioning (used to compensate if a
// later step of the flow fails, so we don't strand a half-provisioned user).
const deleteUserProvisioning = (userId) =>
  request({
    url: userProvisioningAPI.delete(userId),
    method: 'DELETE',
  });

// POST /api/UserStaffRoles — links the invited user to a school-staff record for the roles
// that need one (SafeSpace roles, and Owner in a single-school context).
// body: { staffId, schoolId, userId, roles:[codes] }
const upsertUserStaffRoles = (data) =>
  request({
    url: userProvisioningAPI.upsertUserStaffRoles,
    method: 'POST',
    data,
  });

export default {
  provisionUser,
  deleteUserProvisioning,
  upsertUserStaffRoles,
};
